// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CanonicalEffectChip.css
   The consolidated tooltip-ledger chip. SAME chassis as the in-combat result pill
   (.batch-result-pill--* in BatchBossSession.css) and the keystone-animation
   outcome chips: accent stripe (border-left 2px) + 90deg accent gradient + inset
   accent ring, rounded, ~22px tall. Default face = glyph + word; on hover/focus a
   small popover reveals ONLY the number + magnitude. Bare color literals, NOT
   var(--bcb-*): those tokens live on the combat root and are absent here. */

.tt-effect-chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  padding: 0 9px;
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  font-size: 0.62rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  cursor: default;
  outline: none;
}

/* good / signature keystone reward — the keystone's OWN accent via --tt-accent
   ("r, g, b"), defaulting to metformin-teal (45,212,160). EXACTLY mirrors the beat
   animation's \`.kba__go-pill\` (KeystoneBeatAnimation.css): same stripe 0.85, the
   0.18/0.08 gradient, the 0.16 inset ring, and an uppercase tracked face, so the
   bottom ledger chip is identical to that keystone's reward pill / node color
   (vancomycin red, adalimumab blue, metformin teal). */
.tt-effect-chip--good {
  color: rgba(var(--tt-accent, 45, 212, 160), 0.95);
  border-left: 2px solid rgba(var(--tt-accent, 45, 212, 160), 0.85);
  background:
    linear-gradient(90deg,
      rgba(var(--tt-accent, 45, 212, 160), 0.18) 0%,
      rgba(var(--tt-accent, 45, 212, 160), 0.08) 100%),
    rgba(255, 255, 255, 0.03);
  box-shadow: 0 0 0 1px rgba(var(--tt-accent, 45, 212, 160), 0.16) inset;
}
.tt-effect-chip--good .tt-effect-chip__face {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 800;
}

/* Signature variant — a FAITHFUL scaled replica of the in-combat result pill
   (.batch-result-pill--good-outcome / --vanc-crit): full width, label LEFT
   (flex:1) pushing the value to the RIGHT edge, value shown INLINE. 1:1 with
   .kba__go-pill (KeystoneBeatAnimation.css) so the bottom ledger reward chip is
   identical to that keystone's combat reward pill / beat-animation pill. */
.tt-effect-chip--signature {
  display: flex;
  width: 100%;
  gap: 7px;
}
.tt-effect-chip--signature .tt-effect-chip__face {
  flex: 1 1;
}
/* Value = the combat pill's right-hand magnitude (900 weight, like
   .batch-result-pill-value). renderStatusText keeps its resource glyph + color. */
.tt-effect-chip--signature .tt-effect-chip__value {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-weight: 900;
}

/* green / benefit — heart-glyph green (74,222,128), matching the +5 HP heal chip */
.tt-effect-chip--pos {
  color: rgb(74, 222, 128);
  border-left: 2px solid rgba(74, 222, 128, 0.8);
  background:
    linear-gradient(90deg,
      rgba(74, 222, 128, 0.16) 0%,
      rgba(74, 222, 128, 0.07) 100%),
    rgba(255, 255, 255, 0.03);
  box-shadow: 0 0 0 1px rgba(74, 222, 128, 0.14) inset;
}

/* red / cost — lactic salmon (252,165,165), matching the +1 lactic chip */
.tt-effect-chip--neg {
  color: rgb(252, 165, 165);
  border-left: 2px solid rgba(252, 165, 165, 0.8);
  background:
    linear-gradient(90deg,
      rgba(252, 165, 165, 0.16) 0%,
      rgba(252, 165, 165, 0.07) 100%),
    rgba(255, 255, 255, 0.03);
  box-shadow: 0 0 0 1px rgba(252, 165, 165, 0.14) inset;
}

/* Hover-reveal popover — floats above the chip, shows ONLY the number+magnitude.
   Hidden (and non-interactive) until the chip is hovered or keyboard-focused. */
.tt-effect-chip__detail {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  /* Size to the detail's own content — NOT to the chip. The popover is
     absolutely positioned inside the ~60px-wide chip (position:relative), so a
     plain width:auto shrink-to-fit collapsed it to the chip's width and forced
     short details like "-8% your hits, +12% taken" into an illegible 5-line
     vertical smear that overlapped the tooltip body. width:max-content sizes to
     the content (one line) up to max-width, so short details stay one line and
     only genuinely long ones wrap. (Edward 2026-07-02 — "bugged and illegible"
     tag-hover in the node popup.) */
  width: max-content;
  white-space: normal;
  max-width: 240px;
  line-height: 1.3;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 0.66rem;
  font-weight: 800;
  background: rgba(10, 12, 16, 0.97);
  border: 1px solid currentColor;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5);
  opacity: 0;
  transform: translateY(4px);
  pointer-events: none;
  transition: opacity 120ms ease, transform 120ms ease;
  z-index: 5;
}
/* a tiny pointer so the popover reads as anchored to the chip */
.tt-effect-chip__detail::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 12px;
  border: 4px solid transparent;
  border-top-color: rgba(10, 12, 16, 0.97);
}

.tt-effect-chip:hover .tt-effect-chip__detail,
.tt-effect-chip:focus-visible .tt-effect-chip__detail {
  opacity: 1;
  transform: translateY(0);
}

/* Reduced motion: keep the reveal, drop the slide. */
@media (prefers-reduced-motion: reduce) {
  .tt-effect-chip__detail { transition: opacity 120ms ease; transform: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/PillCard/CanonicalEffectChip.css"],"names":[],"mappings":"AAAA;;;;;;4EAM4E;;AAE5E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,aAAa;AACf;;AAEA;;;;;uDAKuD;AACvD;EACE,iDAAiD;EACjD,iEAAiE;EACjE;;;;6BAI2B;EAC3B,sEAAsE;AACxE;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;2EAI2E;AAC3E;EACE,aAAa;EACb,WAAW;EACX,QAAQ;AACV;AACA;EACE,SAAO;AACT;AACA;kFACkF;AAClF;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,mFAAmF;AACnF;EACE,wBAAwB;EACxB,8CAA8C;EAC9C;;;;6BAI2B;EAC3B,oDAAoD;AACtD;;AAEA,0EAA0E;AAC1E;EACE,yBAAyB;EACzB,+CAA+C;EAC/C;;;;6BAI2B;EAC3B,qDAAqD;AACvD;;AAEA;gFACgF;AAChF;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR;;;;;;;oCAOkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,yCAAyC;EACzC,UAAU;EACV,0BAA0B;EAC1B,oBAAoB;EACpB,oDAAoD;EACpD,UAAU;AACZ;AACA,gEAAgE;AAChE;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;EACE,0BAA0B,8BAA8B,EAAE,eAAe,EAAE;AAC7E","sourcesContent":["/* CanonicalEffectChip.css\n   The consolidated tooltip-ledger chip. SAME chassis as the in-combat result pill\n   (.batch-result-pill--* in BatchBossSession.css) and the keystone-animation\n   outcome chips: accent stripe (border-left 2px) + 90deg accent gradient + inset\n   accent ring, rounded, ~22px tall. Default face = glyph + word; on hover/focus a\n   small popover reveals ONLY the number + magnitude. Bare color literals, NOT\n   var(--bcb-*): those tokens live on the combat root and are absent here. */\n\n.tt-effect-chip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 22px;\n  padding: 0 9px;\n  border-radius: 7px;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  font-size: 0.62rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  cursor: default;\n  outline: none;\n}\n\n/* good / signature keystone reward — the keystone's OWN accent via --tt-accent\n   (\"r, g, b\"), defaulting to metformin-teal (45,212,160). EXACTLY mirrors the beat\n   animation's `.kba__go-pill` (KeystoneBeatAnimation.css): same stripe 0.85, the\n   0.18/0.08 gradient, the 0.16 inset ring, and an uppercase tracked face, so the\n   bottom ledger chip is identical to that keystone's reward pill / node color\n   (vancomycin red, adalimumab blue, metformin teal). */\n.tt-effect-chip--good {\n  color: rgba(var(--tt-accent, 45, 212, 160), 0.95);\n  border-left: 2px solid rgba(var(--tt-accent, 45, 212, 160), 0.85);\n  background:\n    linear-gradient(90deg,\n      rgba(var(--tt-accent, 45, 212, 160), 0.18) 0%,\n      rgba(var(--tt-accent, 45, 212, 160), 0.08) 100%),\n    rgba(255, 255, 255, 0.03);\n  box-shadow: 0 0 0 1px rgba(var(--tt-accent, 45, 212, 160), 0.16) inset;\n}\n.tt-effect-chip--good .tt-effect-chip__face {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 800;\n}\n\n/* Signature variant — a FAITHFUL scaled replica of the in-combat result pill\n   (.batch-result-pill--good-outcome / --vanc-crit): full width, label LEFT\n   (flex:1) pushing the value to the RIGHT edge, value shown INLINE. 1:1 with\n   .kba__go-pill (KeystoneBeatAnimation.css) so the bottom ledger reward chip is\n   identical to that keystone's combat reward pill / beat-animation pill. */\n.tt-effect-chip--signature {\n  display: flex;\n  width: 100%;\n  gap: 7px;\n}\n.tt-effect-chip--signature .tt-effect-chip__face {\n  flex: 1;\n}\n/* Value = the combat pill's right-hand magnitude (900 weight, like\n   .batch-result-pill-value). renderStatusText keeps its resource glyph + color. */\n.tt-effect-chip--signature .tt-effect-chip__value {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-weight: 900;\n}\n\n/* green / benefit — heart-glyph green (74,222,128), matching the +5 HP heal chip */\n.tt-effect-chip--pos {\n  color: rgb(74, 222, 128);\n  border-left: 2px solid rgba(74, 222, 128, 0.8);\n  background:\n    linear-gradient(90deg,\n      rgba(74, 222, 128, 0.16) 0%,\n      rgba(74, 222, 128, 0.07) 100%),\n    rgba(255, 255, 255, 0.03);\n  box-shadow: 0 0 0 1px rgba(74, 222, 128, 0.14) inset;\n}\n\n/* red / cost — lactic salmon (252,165,165), matching the +1 lactic chip */\n.tt-effect-chip--neg {\n  color: rgb(252, 165, 165);\n  border-left: 2px solid rgba(252, 165, 165, 0.8);\n  background:\n    linear-gradient(90deg,\n      rgba(252, 165, 165, 0.16) 0%,\n      rgba(252, 165, 165, 0.07) 100%),\n    rgba(255, 255, 255, 0.03);\n  box-shadow: 0 0 0 1px rgba(252, 165, 165, 0.14) inset;\n}\n\n/* Hover-reveal popover — floats above the chip, shows ONLY the number+magnitude.\n   Hidden (and non-interactive) until the chip is hovered or keyboard-focused. */\n.tt-effect-chip__detail {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  /* Size to the detail's own content — NOT to the chip. The popover is\n     absolutely positioned inside the ~60px-wide chip (position:relative), so a\n     plain width:auto shrink-to-fit collapsed it to the chip's width and forced\n     short details like \"-8% your hits, +12% taken\" into an illegible 5-line\n     vertical smear that overlapped the tooltip body. width:max-content sizes to\n     the content (one line) up to max-width, so short details stay one line and\n     only genuinely long ones wrap. (Edward 2026-07-02 — \"bugged and illegible\"\n     tag-hover in the node popup.) */\n  width: max-content;\n  white-space: normal;\n  max-width: 240px;\n  line-height: 1.3;\n  padding: 3px 8px;\n  border-radius: 6px;\n  font-size: 0.66rem;\n  font-weight: 800;\n  background: rgba(10, 12, 16, 0.97);\n  border: 1px solid currentColor;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  transform: translateY(4px);\n  pointer-events: none;\n  transition: opacity 120ms ease, transform 120ms ease;\n  z-index: 5;\n}\n/* a tiny pointer so the popover reads as anchored to the chip */\n.tt-effect-chip__detail::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 12px;\n  border: 4px solid transparent;\n  border-top-color: rgba(10, 12, 16, 0.97);\n}\n\n.tt-effect-chip:hover .tt-effect-chip__detail,\n.tt-effect-chip:focus-visible .tt-effect-chip__detail {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Reduced motion: keep the reveal, drop the slide. */\n@media (prefers-reduced-motion: reduce) {\n  .tt-effect-chip__detail { transition: opacity 120ms ease; transform: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
